import { from, Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { IAuthDependencySegment } from '../_segments/IAuthDependencySegment';

interface IInitResult {
  authenticated: boolean;
  error?: string;
}

type IDependencies =
  & IAuthDependencySegment;

export const initKeycloak = (dependencies: IDependencies): Observable<IInitResult> => {
  if (dependencies.auth.isInitialized()) {
    return of({ authenticated: dependencies.auth.isAuthenticated() });
  }

  return from(dependencies.auth.init()).pipe(
    map((authenticated) => {
      return { authenticated };
    }),
    catchError((error = 'Unknown error') => {
      // We expect here an error "Failed to refresh token: An unexpected HTTP error occurred while attempting to refresh the token."
      // when there are no tokens in cookies. It is the valid flow, we should redirect to the login page then.
      return of({ authenticated: false, error: error?.error_description ?? error?.error ?? error });
    }),
  );
};
